import { atom } from 'jotai';
export var radiusAtom = atom({
    timeOnline: '',
    isConnected: false,
    framedIpAddress: '',
});
